<template>
    <div class="item-position video-item">
      <div class="video-title disable-select">
        <div>{{craneName}}</div>
        <div>{{videoTitle}}</div>
        <div><img @click="close()" style="cursor: pointer" src="/static/img/close.png" width="20"/></div>
      </div>
      <div class="video-main">
<!--        <video-->
<!--          style="outline: none"-->
<!--          id='myPlayer'-->
<!--          src='ezopen://open.ys7.com/f01018a141094b7fa138b9d0b856507b.live'-->
<!--          width="500"-->
<!--          height="395"-->
<!--          controls-->
<!--          autoplay-->
<!--          playsInline-->
<!--          webkit-playsinline-->
<!--        ></video>-->
        <div id="myPlayer" />
      </div>
    </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
var player = null;
export default {
  name: 'Video',
  data () {
    return {
      player: null
    }
  },
  props: {
    addr: {
      type: String
    },
    videoTitle: {
      type: String
    },
    craneName: {
      type: String
    },
    ysToken: {
      type: String
    }
  },
  watch: {
    addr (val, oldVal) {
      if (val !== oldVal) {
        if (this.player) {
          this.player.stop()
          this.player.play({
            url: val
          });
        }
      }
    }
  },
  methods: {
    close () {
      this.$emit('closeVideoDiv')
    }
  },
  mounted () {
    if (this.addr && this.ysToken) {
      this.player = new EZUIKit.EZUIKitPlayer({
        id: 'myPlayer', // 视频容器ID
        accessToken: this.ysToken,
        url: this.addr,
        template: 'standard', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版; theme-可配置主题；
        autoplay: true,
        width: 500,
        height: 395,
      });
    }
  },
  destroyed () {
    if (this.player) {
      this.player.stop()
    }
  }
}
</script>

<style scoped lang="scss">
  .video-item{
    z-index:999;
    width:500px;
    height:435px;
    left: 1100px;
    top: 20px;
    background-color: #252525;
    /*border: 1px solid #6282b4;*/
    .video-title{
      height:35px;
      color:#ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:0 10px;
    }
    .video-main{
      width:500px;
      height:400px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .disable-select {
      -moz-user-select: none;
      -webkit-user-select:none;
      -ms-user-select:none;
      user-select:none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Video.vue